import ReducerProduto from './cadastro-produto.reducer';


const reducers = {
    reducer: {
        produto: ReducerProduto
    }
}

export {reducers};